import { gql } from '@apollo/client';

export const GET_ALL_DOCUMENT_TYPES = gql`
  query GetAllDocumentTypes($input: GetAllDocumentTypesInput!) {
    documentTypes: getAllDocumentTypes(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          endDate
          expiryDateRequired
          type
        }
      }
    }
  }
`;
